<script>
import MaskedInput from "vue-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import { required } from "vuelidate/lib/validators";
import {cloneDeep} from "lodash";
export default{
    components: {
        MaskedInput,
    },
    data(){
        return {
            submitted: false,
            form: {
                id: 0,
                itemName: "",
                description: "",
                unitId: 0,
                itemCategoryId: 0,
                subType: "",
                unitCost: 0,
            },
            unit: "",
            itemCategory: "",
            currencyMask: createNumberMask({
                prefix: "",
                allowDecimal: true,
            }),
        }
    },
    validations: {
        form: {
            itemName: { required },
            description: { required },
            unitId: { required },
            itemCategoryId: { required },
            unitCost: { required },
            subType: { required },
        },
    },
    methods: {
        onCreate() {
            this.submitted = true;
            this.$v.form.$touch();
            if (this.$v.form.$invalid) {
                return;
            }
            this.$emit('updateItemRequest', this.form)
        },
        putData(item){
            this.form = cloneDeep(item);
            this.unit = item.unit.unitName || item.unit;
            this.itemCategory = item.itemCategory.name || item.itemCategory;
            this.form.unitCost = item.unitCost.toString();
        },
        dropUnit(data) {
            this.unit = data.unitName;
            this.form.unitId = data.id;
            this.form.unit = data;
        },
        dropItemCat(data) {
            this.itemCategory = data.name;
            this.form.itemCategoryId = data.id;
            this.form.itemCategory = data;
        },
    }
}
</script>
<template>
    <b-modal
        id="item-update-modal"
        title="Update Item"
        size="md"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
    >
        <form
            @submit.prevent="onCreate"
            class="needs-validation mx-2"
            ref="fcForm"
        >
            <div class="mb-3">
                <label for="itemName">Item Name</label>
                <input
                    autocomplete="off"
                    id="itemName"
                    type="text"
                    v-model="form.itemName"
                    placeholder="Enter Item Name..."
                    class="form-control"
                    :class="{ 'is-invalid': submitted && $v.form.itemName.$error}"
                />
                <div v-if="submitted && $v.form.itemName.$error" class="invalid-feedback">
                    <span v-if="!$v.form.itemName.required">This value is required.</span>
                </div>
            </div>
            <div class="mb-3">
                <label for="description">Specifications</label>
                <textarea
                    id="description"
                    type="text"
                    v-model="form.description"
                    placeholder="Enter Specifications..."
                    class="form-control"
                    :class="{ 'is-invalid': submitted && $v.form.description.$error}"
                ></textarea>
                <div v-if="submitted && $v.form.description.$error" class="invalid-feedback">
                    <span v-if="!$v.form.description.required">This value is required.</span>
                </div>
            </div>
            <div class="mb-3">
                <label for="unitId">Unit </label>
                <b-input-group>
                    <template #append>
                        <b-button
                            @click="$emit('getUnit')"
                            variant="outline-info"
                        >
                            <i class="mdi mdi-clipboard-text-search-outline"></i>
                        </b-button>
                    </template>
                    <input
                        autocomplete="off"
                        type="text"
                        disabled
                        placeholder="Search Unit..."
                        class="form-control"
                        :class="{'is-invalid': submitted && $v.form.unitId.$error}"
                        v-model="unit"
                    />
                </b-input-group>
                <div v-if="submitted && $v.form.unitId.$error" class="invalid-feedback">
                    <span v-if="!$v.form.unitId.required">This value is required.</span>
                </div>
            </div>
            <div class="mb-3">
                <label for="itemCategoryId"
                    >Item Category
                </label>
                <b-input-group>
                    <template #append>
                        <b-button
                            @click="$emit('getItemCategory')"
                            variant="outline-info"
                        >
                            <i class="mdi mdi-clipboard-text-search-outline"></i>
                        </b-button>
                    </template>
                    <input
                        autocomplete="off"
                        type="text"
                        disabled
                        placeholder="Search Item Category..."
                        class="form-control"
                        :class="{ 'is-invalid': submitted && $v.form.itemCategoryId.$error}"
                        v-model="itemCategory"
                    />
                </b-input-group>
                <div v-if="submitted && $v.form.itemCategoryId.$error" class="invalid-feedback">
                    <span v-if="!$v.form.itemCategoryId.required">This value is required.</span>
                </div>
            </div>
            <div class="mb-3">
                <label for="subType">Sub Type</label>
                <select
                    class="form-select"
                    id="subType"
                    v-model="form.subType"
                    placeholder="Select Sub Type..."
                    :class="{ 'is-invalid': submitted && $v.form.subType.$error}"
                >
                    <option></option>
                    <option value="Goods">Goods</option>
                    <option value="Services">Goods (General Support Services)</option>
                    <option value="Consultancy">Consulting Services</option>
                    <option value="Infrastructure">Infrastructure Projects</option>
                </select>
                <div v-if="submitted && $v.form.subType.$error" class="invalid-feedback">
                    <span v-if="!$v.form.subType.required">This value is required.</span>
                </div>
            </div>
            <div class="mb-3">
                <label for="unitCost">Unit Cost </label>
                <masked-input
                    autocomplete="off"
                    id="unitCost"
                    type="text"
                    v-model="form.unitCost"
                    class="form-control"
                    :class="{ 'is-invalid': $v.form.unitCost.$error}"
                    :mask="currencyMask"
                ></masked-input>
                <div v-if="submitted && $v.form.unitCost.$error" class="invalid-feedback">
                    <span v-if="!$v.form.unitCost.required">This value is required.</span>
                </div>
            </div>
            <div class="modal-footer">
                <button
                    type="submit"
                    class="btn btn-primary"
                >
                    {{this.form.id == 0 ? 'Save' : 'Update'}} changes
                </button>
                <button
                    type="button"
                    class="btn btn-link"
                    @click="$bvModal.hide('item-update-modal')"
                >
                    Close
                </button>
            </div>
        </form>
    </b-modal>
</template>